import { useContext, useRef, useEffect, useCallback } from 'react'
import { GlobalContext } from '../context/global.context'

const parseExtendedFeedQuery = (query, data) => {
    query = query || ''
    data = data || {}
    query = query.replace(/,/g, '&')
    Object.keys(data).map((key) => {
        const pattern = new RegExp(`{${key}}`, 'g');
        query = query.replace(pattern, data[key] || '')
        return null
    })
    return query
}

const useParseExtendedFeedQuery = () => {
    const { userInfo } = useContext(GlobalContext)
    const userInfoRef = useRef(userInfo)

    useEffect(() => { userInfoRef.current = userInfo }, [userInfo])

    const parseEQ = useCallback((query, data) => {
        query = query || ''
        data = data || {}
        const userInfo = userInfoRef.current || {}
        const userId = userInfo.userId || ''
        data = { user_id: userId, ...data }
        return parseExtendedFeedQuery(query, data)
    }, [])

    return parseEQ
}

export default useParseExtendedFeedQuery